<template>
    <span>
        <img v-if="width" :width="width" :src="`${siteUrl}/no_image_available_1_14.gif`" />
        <img v-else :src="`${siteUrl}/no_image_available_1_14.gif`" />
    </span>
</template>

<script>
import { settings } from '../../framework/settings';
export default {
    props: {
        width: {
            type: String,
        }
    },
    data() {
        return {
            siteUrl: settings.siteUrl
        }
    },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/primitives/NoImage.vue